<template>
  <v-container fluid>
    <v-row justify-center>
      <v-col offset="3" cols="6">
        <v-card class="mt-15" elevation = "15">
          <v-container fluid fill-height>
            <v-row justify-center>
              <v-col offset="3" cols="6">
                <v-img
                  max-width="300"
                  max-height="300"
                  position="center center"
                  src="../assets/Success.png"
                ></v-img>
              </v-col>
            </v-row>
            <v-row>
                <v-col offset= "4">
                    <h2>الطلب تم بنجاح</h2>
                </v-col>
            </v-row>
            <v-row justify-center>
              <v-col offset="4" cols="6">
                <v-btn rounded @click="BackToHome">العودة الى الصفحة الرئيسية</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    methods:{
        BackToHome(){
            this.$router.push({ name: "home" });
        }
    }
};
</script>

<style>
</style>